import {
  DEFAULT_INVALID_DATE,
  type FormatIntlType,
  convertDetectedLanguageTag,
  formatIntlDateOrRangeValue,
} from '@pba/react-utils';
import { formatDistanceToNow, isDate } from 'date-fns';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { resources, supportedAppLanguageCodes } from './config';
import { dateFnsLocales } from './date-fns';
import { isAppLanguage } from './is-app-language';

const getLocale = (language?: string) => {
  if (!language) {
    return undefined;
  }

  if (!isAppLanguage(language)) {
    throw new Error(`Unsupported language: ${language}`);
  }

  return dateFnsLocales[language].locale;
};

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: false,

    defaultNS: 'translations',
    detection: {
      caches: ['localStorage'],
      convertDetectedLanguage: convertDetectedLanguageTag,
      lookupLocalStorage: 'lang',
      order: ['localStorage', 'navigator'],
    },

    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    ns: ['translations', 'translationChat'],
    nsSeparator: false,
    resources,
    supportedLngs: supportedAppLanguageCodes,
  });

const formats: Array<'age' | FormatIntlType> = [
  'dayNumberShortDay',
  'longMonth',
  'monthYear',
  'shortMonth',
  'shortMonthDay',
  'shortMonthDayYear',
  'time',
  'dateTime',
  'age',
  'dayShortMonthDay',
  'dayShortMonthDayYear',
  'dayNumber',
  'dayShort',
  'dayLong',
];

for (const type of formats) {
  i18n.services.formatter?.add(type, (value, lng) => {
    const lang = lng && isAppLanguage(lng) ? lng : undefined;

    if (type === 'age') {
      return isDate(value) ? formatDistanceToNow(value, { locale: getLocale(lng) }) : DEFAULT_INVALID_DATE;
    }

    return formatIntlDateOrRangeValue({ lang, type, value });
  });
}
